import TypeOfInstalation from "./TypeOfInstalation";

export default TypeOfInstalation;